var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRechargeIconPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 19,
    viewBox: "0 0 12 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.57448,
    y: 0.57448,
    width: 10.751,
    height: 17.1587,
    rx: 1.31707,
    stroke: "#ACB7C5",
    strokeWidth: 1.14896
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.30859 15.7192H7.84166",
    stroke: "#ACB7C5",
    strokeWidth: 0.820686,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRechargeIconPlaceholder);
export default __webpack_public_path__ + "static/media/RechargeIconPlaceholder.d277ab471308020944469b894cada6ca.svg";
export { ForwardRef as ReactComponent };